import _ from "lodash";

export default (allPackage) => ({
    open: false,
    showPhotos: false,
    package: {},

    packagesData: [],

    currentIndex: null,
    defaultImage: {'thumb': '/images/no-photo.png'},

    init() {
        window.addEventListener('grouped::add-to-product', ({detail}) => this.selectPhoto(detail));

        window.addEventListener('open-package', ({detail}) => this.setPackage(detail));
        window.addEventListener('edit-package', ({detail}) => this.editPackage(detail));

        window.addEventListener('close-package', () => this.open = false);
        window.addEventListener('place-order', () => this.open = false);

        window.addEventListener('cart::add-package', async ({detail: packageItem}) => {
            if (packageItem.template?.is_digital === allPackage) {
                await this.$store.customerImages.loadSavedPhotos();
                this.$store.packageData.images['all'] = Object.values(this.$store.customerImages.images);
            }

            this.$store.cart.addPackage(
                Object.assign(
                    this.$store.packageData.get(),
                    {
                        package: packageItem,
                        is_digital: packageItem.template?.is_digital ?? false,
                        quantity: 1,
                        saved: true
                    },
                ),
                true
            );
        });
    },

    requirements() {
        return _.get(this.package.template, 'requirement_images', []);
    },

    selectPhoto(images) {
        this.$store.packageData.images[this.currentIndex] = {};
        const requirement = this.requirements()[this.currentIndex];

        Object.values(images).map((image) => {
            this.$store.packageData.images[this.currentIndex][image.id] = {
                ...image,
                'requirement': requirement.name
            };
        });
    },

    async choosePhotos(index) {
        this.currentIndex = index;

        await this.$store.customerImages.loadSavedPhotos();

        this.$dispatch('open:package-select-photos', {
            images: this.$store.customerImages.groupedImages(),
            quantity: this.requirements()[index].quantity,
            selected: this.$store.packageData.images[index],
            currentIndex: index,
        });
    },

    isSelected(imageId) {
        return this.$store.packageData.hasImage(imageId, this.currentIndex);
    },

    getImage(index, imageIndex) {
        const image = this.$store.packageData.getImage(index, imageIndex);

        return image.thumb || this.defaultImage.thumb;
    },

    editPackage(data) {
        this.getPackage(data.package.id);

        this.$store.packageData.set(data);

        this.open = true;
    },

    getPackage(packageId) {
        const currentPackage = this.$store.packages.all().find(({id}) => id === packageId);
        this.package = currentPackage;

        return currentPackage;
    },

    setPackage(packageId) {
        const currentPackage = this.getPackage(packageId);

        this.$store.packageData.set({
            athlete: null,
            jersey: null,
            images: {}
        });

        if (!this.hasRequirements(currentPackage)) {
            this.addToCart(false);
            return;
        }

        if (currentPackage) {
            this.open = true;
        }
    },

    loadPackageData() {
        this.packagesData = {};

        this.$store.cart.items.forEach((currentData) => {
            this.packagesData[currentData.package.id] = Object.assign({}, currentData);
        });
    },

    async addToCart(check = true) {
        this.loadPackageData();

        if (check && !this.checkRequirements()) {
            return;
        }

        if (this.package.template.is_digital === allPackage) {
            await this.$store.customerImages.loadSavedPhotos();
            this.$store.packageData.images['all'] = Object.values(this.$store.customerImages.images);
        }

        this.packageData = Object.assign(
            this.$store.packageData.get(),
            {
                package: this.package,
                is_digital: this.package.template.is_digital ?? false,
                quantity: _.get(this.$store.packageData, 'quantity', 1),
                saved: true
            },
        );

        if (!this.hasRequirements(this.package)) {
            const packageIndex = this.$store.cart.items.findIndex(
                (cartItem) => cartItem.package.id == this.package.id
            );

            this.packageData.index = packageIndex > -1 ? packageIndex : null;
        }

        this.$store.cart.addPackage(
            this.packageData,
            _.get(this.packageData, 'index') !== null
        );

        if (this.checkUpsell() === false) {
            return;
        }

        this.checkAddons();
        this.open = false;

        window.$wireui.notify({
            title: 'Product saved to the cart!',
            description: 'Your product was successfully saved',
            icon: 'success',
            timeout: '1400',
            progressbar: false
        });

        if (!this.package.addons.length) {
            this.$dispatch('open-cart');
        }
    },

    checkUpsell() {
        const customer = this.$store.customer.item;

        if (customer.deposits > 1 && this.package.upsell) {
            for (let i = 0; i < customer.deposits; i++) {
                this.$store.cart.addPackage(
                    this.packagesData[this.package.id],
                    true
                );
            }
        }

        if (this.package.addons.length && this.package.upsell) {
            return;
        }

        if (customer.deposits >= 1 && this.package.upsell) {
            if (!this.$store.customer.hasInfo()) {
                this.$dispatch('open-create-account');

                return false;
            }

            this.$wire.dispatch('customer::form::setStep', {step: 'agreements'});
            this.$dispatch('place-order');
            this.$dispatch('close-cart');
        }

        this.$dispatch('show-upsells');
        return true;
    },

    checkAddons() {
        let cartItemIds = this.$store.cart.items.map((item) => {
            return item.package.id;
        })

        if (this.package.addons.length && !cartItemIds.includes(this.package.addons[0].id)) {
            this.$dispatch('show-add-ons', this.package.addons);
        }
    },

    hasRequirements(currentPackage) {
        return _.get(currentPackage?.template, 'requirement_images', [])?.length ?? 0;
    },

    checkRequirements() {
        let hasError = false;
        let errors = [];

        if (!this.package.template.hide_player_name && !this.$store.packageData.athlete) {
            errors.push('Athlete First & Last Name');
        }

        if (!this.package.template.hide_player_number && !this.$store.packageData.jersey) {
            errors.push('Jersey Number');
        }

        if (errors.length) {
            window.$wireui.notify({
                description: 'The fields (' + errors.join(', ') + ') are mandatory.',
                icon: 'warning',
                timeout: '1400',
                progressbar: false
            });

            hasError = true;
        }

        if (this.$store.packageData.imagesQuantity() < 1) {
            window.$wireui.notify({
                title: 'Unable to add package!',
                description: 'You need to select an image for the pack',
                icon: 'warning',
                timeout: '1400',
                progressbar: false
            });

            hasError = true;
        }

        return !hasError;
    }
});
